
import { StockTransactionDto, CreateStockTransactionDto } from '@services/dtos'
import { baseCrudReducer } from './baseCrudReducer'
import { stockTransactionService, StockTransactionsFilters } from '@services/StockTransactionService'

const { reducer, actions, thunks } = baseCrudReducer<
  StockTransactionDto,
  CreateStockTransactionDto,
  {},
  StockTransactionsFilters
>('stockTransaction', stockTransactionService)

export default reducer

export const { setFilters: setStockTransactionFilters } = actions

export const {
  getAll: getStockTransactions,
  create: createStockTransaction,
  remove: removeStockTransaction,
} = thunks
